import { zeroAddress } from 'viem'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const BERACHAIN = {
  name: 'berachain',
  chainId: 80094,
  averageBlockTimeSeconds: 2,
  explorerUrl: 'https://berascan.com/',
  nativeAsset: {
    assetAddress: zeroAddress,
    decimals: 18,
    name: 'BERA',
    symbol: 'BERA',
  },
  slip44: 60,
  wrappedNativeAsset: '0x6969696969696969696969696969696969696969',
  blockscoutApiUrl: undefined,
  etherscanSupported: true,
  publicRpcUrls: ['https://berachain-mainnet.g.alchemy.com/public', 'https://rpc.berachain.com'],
  getPrivateRpcUrls: () => {
    const berachain: string[] = []
    process.env.ROUTEME_API_KEY && berachain.push(`https://lb.routeme.sh/rpc/80094/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('berachain')
    quickNodeUrl && berachain.push(quickNodeUrl)
    process.env.ALCHEMY_API_KEY &&
      berachain.push(`https://berachain-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    return berachain
  },
} as const satisfies ChainConfig
